import React, { Component } from "react";
import PropTypes from "prop-types";
import Header from "../Header/Header";
import Main from "../Main/Main";
import { Switch, Route } from "react-router-dom";
import Home from "../Home/Home";
import Transfer from "../Transfer/Transfer";
import ConfirmTransfer from "../ConfirmTransfer/ConfirmTransfer";
import Search from "../Search/Search";
import SignIn from "../SignIn/SignIn";
import ConfirmSignIn from "../ConfirmSignIn/ConfirmSignIn";
import CreateRequest from "../CreateRequest/CreateRequest";
import Request from "../Request/Request";
import FulfillRequest from "../FulfillRequest/FulfillRequest";
import Pse from "../Pse/Pse";
import EditProfile from "../EditProfile/EditProfile";
import Scan from "../Scan/Scan";
import "./App.css";

class App extends Component {
  constructor() {
    super();

    this.state = {
      isSignedIn: !!localStorage.getItem("token"),
      tag: ""
    };

    this.onSignIn = this.onSignIn.bind(this);
    this.onSignOut = this.onSignOut.bind(this);
  }

  componentDidMount() {
    const tag = localStorage.getItem("tag");
    const signerHandle = localStorage.getItem("signerHandle");
    const phoneNumber = localStorage.getItem("phoneNumber");

    if (tag && signerHandle && phoneNumber) {
      this.setState({ tag, signerHandle, phoneNumber, isSignedIn: true });
    }
  }

  getChildContext() {
    return {
      isSignedIn: this.state.isSignedIn,
      tag: this.state.tag
    };
  }

  onSignIn(data) {
    const { tag, signerHandle, phoneNumber } = data;

    localStorage.setItem("tag", tag);
    localStorage.setItem("signerHandle", signerHandle);
    localStorage.setItem("phoneNumber", phoneNumber);

    this.setState({ tag, signerHandle, phoneNumber, isSignedIn: true });
  }

  onSignOut() {
    localStorage.clear();
    this.setState({ isSignedIn: false });
  }

  render() {
    const { isSignedIn, tag } = this.state;

    return (
      <div className="App">
        <Header tag={tag} onSignedOut={this.onSignOut} />
        <Main>
          {!isSignedIn && (
            <Switch>
              <Route exact path="/" component={SignIn} />
              <Route
                path="/ingresar/confirmar"
                render={props => (
                  <ConfirmSignIn {...props} onSignedIn={this.onSignIn} />
                )}
              />
              <Route path="/ingresar" component={SignIn} />
              <Route path="/s/:id" component={FulfillRequest} />
              <Route path="/pse/banka/:id" component={Pse} />
            </Switch>
          )}
          {isSignedIn && (
            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/buscar" component={Search} />
              <Route exact path="/transferir/:to?" component={Transfer} />
              <Route
                path="/transferir/:to?/:amount?/:description?"
                component={ConfirmTransfer}
              />
              <Route path="/solicitar/" exact component={CreateRequest} />
              <Route path="/solicitar/:id" component={Request} />
              <Route path="/s/:id" component={FulfillRequest} />
              <Route path="/perfil" component={EditProfile} />
              <Route path="/escanear" component={Scan} />
            </Switch>
          )}
        </Main>
      </div>
    );
  }
}

App.childContextTypes = {
  isSignedIn: PropTypes.bool,
  tag: PropTypes.string
};

export default App;



// WEBPACK FOOTER //
// ./src/App/App.js